import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {DefaultSettingsService} from '../default-settings-service.service';
import {ExcListComponent, ExcListConfig, SortHelperDataInterface} from 'exc-controls';
import {ModalDispositionMapComponent} from '../modals/modal-disposition-map/modal-disposition-map.component';
import {ExcFilter, ExcFilterCondition, ExcSort, FilterSortService} from '../filter-sort-service.service';
import {ProviderModalDispositionBatchComponent} from '../provider/modals/provider-modal-disposition-batch/provider-modal-disposition-batch.component';

@Component({
  selector: 'app-audit-disposition',
  templateUrl: './audit-disposition.component.html',
  styles: []
})
export class AuditDispositionComponent extends ExcTranslation implements OnInit {
  @ViewChild('mapInstance') mapContainer: any;
  @ViewChild('filterMenu') filterMenu;
  @ViewChild('filterAuditorMenu') filterAuditorMenu;
  @ViewChild('lstAuditors') lstAuditors: ExcListComponent;
  @ViewChild('lstAudits') lstAudits: ExcListComponent;
  data = {Audits: [], Auditors: []};
  searchValues = {Audit: null, Auditor: null};
  paging = {Audits: null, Auditors: null};
  selection = {Audit: null, Auditor: null, AuditList: [], AuditorList: [], Month: (new  Date()).getMonth() + 1, Year: (new Date().getFullYear())};
  auditListConfig: ExcListConfig = new ExcListConfig();
  auditorListConfig: ExcListConfig = new ExcListConfig();
  mapObjects = {Auditor: null,  Audit: null};
  public sortValue: { key: 'asc' | 'desc' } | {} = {};
  public sortData: SortHelperDataInterface[];
  popupData = {Year: (new Date()).getFullYear(), Month: (new Date()).getMonth() + 1  };
  optionsMonth: any[] = [];
  optionsYear: any[] = [];
  isLoading = true;
  auditFlt: {sort: ExcSort[], filter: ExcFilter[]} = {sort: [], filter: []};
  auditorFlt: {sort: ExcSort[], filter: ExcFilter[]} = {sort: [], filter: []};

  constructor(private excRest: ExcRestService, private excDss: DefaultSettingsService, private excFss: FilterSortService, private cdr: ChangeDetectorRef) {
    super();
    const _self = this;
    for (let i = 1; i <= 12; i++) {
      _self.optionsMonth.push({text: i, value: i});
    }
    for (let i = -3; i <= 3; i++) {
      _self.optionsYear.push({text: (new Date()).getFullYear() + i, value: (new Date()).getFullYear() + i});
    }
    _self.auditListConfig.selectionMode = 'multi';
    _self.auditListConfig.selectFirstAfterInit = true;
    _self.auditListConfig.OnFocus = (focusItem, event) => {
      _self.selection.Audit  = focusItem;
      _self.loadAuditors();
      _self.mapObjects.Audit = _self.selection.Audit;
    };
    _self.auditListConfig.OnSelectionChanged = (items, event?) => {
      _self.selection.AuditList = items;
      // _self.updateMap();
    };
    _self.auditListConfig.OnSearch = (searchValue) => {
      _self.searchValues.Audit = searchValue;
      _self.reLoadAudits();
    };
    _self.auditListConfig.OnFilter = (flt, event?) => {

    };
    _self.auditListConfig.OnFilterClick = (event) => {
      _self.filterMenu.show(event);
    };
    _self.auditListConfig.OnPageChanged = (pageNo, event1) => {
      _self.auditListConfig.paging.pagingPage = pageNo;
      _self.reLoadAudits();
    };
    _self.auditorListConfig.selectionMode = 'multi';
    _self.auditorListConfig.selectFirstAfterInit = true;
    _self.auditorListConfig.OnFocus = (focusItem, event) => {
      _self.selection.Auditor = focusItem;
      _self.mapObjects.Auditor = _self.selection.Auditor;
    };
    _self.auditorListConfig.OnSelectionChanged = (items, event?) => {
      _self.selection.AuditorList = items;
    };
    _self.auditorListConfig.OnSearch = (searchValue) => {
      _self.searchValues.Auditor = searchValue;
      _self.loadAuditors();
    };
    _self.auditorListConfig.OnFilter = (flt, event?) => {

    };
    _self.auditorListConfig.OnFilterClick = (event) => {
      _self.filterAuditorMenu.show(event);
    };
    _self.auditorListConfig.OnPageChanged = (pageNo, event1) => {
      _self.auditorListConfig.paging.pagingPage = pageNo;
      _self.loadAuditors();
    };
    _self.auditorFlt.sort.push(new ExcSort('AdmName', 0, 'AuditDispositionComponent.AuditorLastname', 0));
    _self.auditorFlt.sort.push(new ExcSort('WorkloadPercent', 0, 'AuditDispositionComponent.Workload', 0));
    _self.auditorFlt.sort.push(new ExcSort('Audits', 0, 'AuditDispositionComponent.AuditorTaskCount', 0));
    _self.auditorFlt.sort.push(new ExcSort('Distance', 0, 'AuditDispositionComponent.Distance', 0));
    for (const x of _self.auditorFlt.sort) {
      x['Container'] = _self.auditorFlt.sort;
    }

  }

  ngOnInit() {
    const _self = this;
    _self.selection.Auditor = {};
    _self.selection.Audit = null;
    _self.initialLoad();
  }

  initialLoad() {
    const _self = this;
    const url = this.excRest.computeUrl('DispositionR_Summary', {month: _self.selection.Month, year: _self.selection.Year});
    _self.auditListConfig.isLoading = true;
    let mi = _self.auditListConfig.GetMetaInfo();
    mi =  _self.excFss.ApplyFilter(mi, this.auditFlt.filter, this.auditFlt.sort);
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.data.Audits = ret.data.Audits;
        _self.paging.Audits = ret.paging.Audits;
        _self.auditListConfig.paging = _self.paging.Audits;
        for (const x of ret.data.Mandant) {
          _self.auditFlt.filter.push(new ExcFilter(1, 'Globals.Client', 'Mandant'
            , new ExcFilterCondition('=', x.Mandant), 'fltClient', x.MandantName, 0));
        }
        _self.auditListConfig.isLoading = false;
        _self.isLoading = false;
      }
    });
    _self.auditFlt.sort.push(new ExcSort('Mandant', 0, 'Client', 0));
    _self.auditFlt.sort.push(new ExcSort('DealerName', 0, 'DealerName', 1));
    _self.auditFlt.sort.push(new ExcSort('DealerLevel1', 0, 'DealerNumber', 0));

    for (const x of _self.auditFlt.filter) {
      x['Container'] = _self.auditFlt.filter;
    }

    for (const x of _self.auditFlt.sort) {
      x['Container'] = _self.auditFlt.sort;
    }
  }

  applyFilterAudit() {
    this.filterMenu.hide();
    this.reLoadAudits();
  }

  resetFilterAudit() {
    this.excFss.ResetFilter(this.auditFlt.filter, this.auditFlt.sort);
    this.filterMenu.hide();
    this.reLoadAudits();
  }

  applyFilterAuditor() {
    this.filterAuditorMenu.hide();
    this.loadAuditors();
  }

  resetFilterAuditor() {
    this.excFss.ResetFilter(this.auditorFlt.filter, this.auditorFlt.sort);
    this.filterAuditorMenu.hide();
    this.loadAuditors();
  }
  setSortData() {
    const _self = this;
    _self.sortData = [
      {
        get displayName() {
          return _self.getRessource('Client');
        },
        key: 'Mandant'
      },
      {
        get displayName() {
          return _self.getRessource('Last1Auditor');
        },
        key: 'AuditLast1Auditor'
      }
    ];
  }
  openBatchDialoge() {
    const _self = this;

    ExcCoreModule.showModal(ProviderModalDispositionBatchComponent, null, 'xl', {Audits: _self.selection.AuditList, Auditors: _self.selection.AuditorList}, false, null).subscribe(ret => {

      _self.selection.AuditList = [];
      _self.selection.AuditorList = [];
      _self.lstAuditors.deselectAll();
      _self.lstAudits.deselectAll();
      _self.lstAudits.clearSelection(null);
      _self.lstAuditors.clearSelection(null);
      _self.cdr.detectChanges();
         setTimeout(() => {
          _self.selection.AuditList = [];
          _self.selection.AuditorList = [];
          _self.lstAuditors.deselectAll();
          _self.lstAudits.deselectAll();
          _self.lstAudits.clearSelection(null);
          _self.lstAuditors.clearSelection(null);
          _self.cdr.detectChanges();
         }, 100);
         if (ret.Proceed === true) {
           const url = _self.excRest.computeUrl('Provider_AuditU_BatchAssign', {});
           _self.excRest.post(url, {JSON: ret.AuditData}, {}).subscribe(x => {
             _self.initialLoad();
           });
         }
    });
  }

  openDialoge() {
    const _self = this;
    const warningMessage = _self.getRessource('Warning', {AuditorName: _self.selection.Auditor.AdmName});
       ExcCoreModule.showModal(warningMessage, _self.getRessource('Dispose'), 's', null, true, [ {
         text: this.getGlobal('No'),
         class: 'btn btn-submit',
         onClick: (overlay) => {
           overlay.close(false);
         }
       }, {
         text: this.getGlobal('Yes'),
         class: 'btn btn-submit',
         onClick: (overlay) => {
           overlay.close(true);
           _self.disposeAudites();
         }
       }]).subscribe(x => {
    });
  }

  disposeAudites() {
    const _self = this;

    _self.excRest.post(_self.excRest.computeUrl('DispositionU', {}),
      {
        AuditorID: _self.selection.Auditor.AdmID,
        Audits: _self.selection.Audit.AuditID
      }, {})
      .subscribe(response => {
        _self.loadAuditors();
        _self.reLoadAudits();
      });
  }

  getWorkIndicatorStyle(d) {
        return {width:  'calc(' + d.WorkloadPercent + '% - 0.5rem)'
          , padding: '0 0.25rem 0 0.25rem'
          , lineHeight: '1.1rem'
          , minHeight: '1.1rem'
          , float: 'left'
          // , background: 'linear-gradient(270deg, rgba(0,255,0,1) 0%, rgba(255,255,0,1) 50%, rgba(255,0,0,1) 100%)'
          , borderColor: '1x black solid'
      };
  }

  getWorkIndicatorStyleNegative(d) {
    return {width:  'calc(' + (100 - d.WorkloadPercent) + '% - 0rem)'
        , background: 'white'  , padding: '0 0.25rem 0 0.25rem'
      , left: 'calc(' + d.WorkloadPercent + '% - 0.5rem)'
      , lineHeight: '1.1rem'
      , minHeight: '1.1rem'
      , borderColor: '1x black solid'
      , position: 'relative'

    };
  }

  loadAuditors() {
    const _self = this;
    if (_self.selection.Audit === null) {
      return;
    }
    _self.selection.Auditor = null;
    let mi = this.auditorListConfig.GetMetaInfo();
    mi =  this.excFss.ApplyFilter(mi, this.auditorFlt.filter, this.auditorFlt.sort);
    const url = this.excRest.computeUrl('DispositionAuditR_ListAuditors', {AuditID: _self.selection.Audit.AuditID, fts: _self.searchValues.Auditor});
    _self.auditorListConfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.data.Auditors = ret.data;
        _self.paging.Auditors = ret.paging;
        _self.auditorListConfig.paging = _self.paging.Auditors;
      }
      _self.auditorListConfig.isLoading = false;

    });
  }

  reLoadAudits() {
    const _self = this;
    let mi = _self.auditListConfig.GetMetaInfo();
    mi =  _self.excFss.ApplyFilter(mi, this.auditFlt.filter, this.auditFlt.sort);
    const url = this.excRest.computeUrl('DispositionR_ListAudits', {month: _self.popupData.Month, year: _self.popupData.Year, fts: _self.searchValues.Audit});
    _self.auditListConfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.data.Audits = ret.data;
        _self.paging.Audits = ret.paging;
        _self.auditListConfig.paging = _self.paging.Audits;
        _self.auditListConfig.isLoading = false;
      }
    });
  }

  isAuditorsAvailable() {
    const _self = this;
    let isAvailable = false;
    if (_self.selection.Auditor) {
      isAvailable = true;
    }
    return isAvailable;
  }

  openMapModal() {
    const _self = this;
    ExcCoreModule.showModal(ModalDispositionMapComponent, _self.getRessource('MapView'), 'xl', {selection: _self.selection}, true, []).subscribe(ret => {
    });
  }
}
